module.exports = __webpack_public_path__ + "img/cmnd-front-1.ca33cb7d.png";